import styled from 'styled-components';
import { Img } from 'react-image';

const Button = styled.button`
  color: white;
  background-color: ${props => props.theme.btnPrimaryBackgroundColor};
  border: none;
  border-radius: 4px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-transform: uppercase;

  &:hover {
    background-color: ${props => props.theme.btnPrimaryHoverBackgroundColor};
  }
`;

const SmallButton = styled(Button)`
  font-size: 14px;
  padding: 10px 20px;
`;

const BigButton = styled(Button)`
  font-size: 20px;
  padding: 20px 28px;
`;

const PaddedContainer = styled.div`
  ${props => (props.theme.isMobile
    ? `
      margin: 0 20px;
      width: auto;
    `
    : `
      margin: 0 auto;
      max-width: 1230px;
      width: 85.4vw;
    `
  )};
`;

const Logo = styled(Img)`
  min-width: 72px;
  width: 96px;
`;

const SectionName = styled.span`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: ${props => (props.theme.isMobile ? 17 : 20)}px;
  line-height: ${props => (props.theme.isMobile ? 17 : 20)}px;
  color: ${props => props.theme.primaryColor};
  text-transform: uppercase;
`;

const SectionTitle = styled.p`
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: ${props => (props.theme.isMobile ? 35 : 40)}px;
  line-height: ${props => (props.theme.isMobile ? 46 : 52)}px;
`;

const Page = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
`;

const buildPlxData = (id, topOffset, bottomOffset) => {
  bottomOffset = bottomOffset === undefined ? topOffset : bottomOffset;
  const common = {
    start: id,
    duration: id,
    easing: 'easeInOutQuad',
  };
  const scrollIn = {
    endValue: 0,
    property: 'translateY',
  };
  const scrollOut = {
    startValue: 0,
    property: 'translateY',
  };
  return {
    text: [{
      ...common,
      properties: [{
        ...scrollIn,
        startValue: 0.5 * topOffset,
      }],
    }, {
      ...common,
      startOffset: '100vh',
      properties: [{
        ...scrollOut,
        endValue: -0.5 * bottomOffset,
      }],
    }],
    image: [{
      ...common,
      properties: [{
        ...scrollIn,
        startValue: -0.5 * topOffset,
      }],
    }, {
      ...common,
      startOffset: '100vh',
      properties: [{
        ...scrollOut,
        endValue: 0.5 * bottomOffset,
      }],
    }],
  };
};

export {
  buildPlxData,
  BigButton,
  Button,
  Logo,
  PaddedContainer,
  Page,
  SmallButton,
  SectionName,
  SectionTitle,
};
